import { ChangeDetectionStrategy, Component, HostBinding, Input } from "@angular/core";
import { AttributePresenceInput } from "@spscommerce/ng-utils";

@Component({
    selector: "sps-content-row-col",
    templateUrl: "./sps-content-row-col.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpsContentRowColComponent {
    static readonly displayName = "sps-content-row-col";
    static readonly props = {
        width: "string",
        borderless: "boolean",
        lean: "boolean",
        leaner: "boolean",
    };

    @Input()
    @HostBinding("style.width")
    width: string;

    @Input()
    @AttributePresenceInput()
    @HostBinding("class.sps-content-row__col--borderless")
    borderless: boolean;

    @Input()
    @AttributePresenceInput()
    @HostBinding("class.sps-content-row__col--lean")
    lean: boolean;

    @Input()
    @AttributePresenceInput()
    @HostBinding("class.sps-content-row__col--leaner")
    leaner: boolean;

    @HostBinding("class.sps-content-row__col") readonly _spsContentRowColClass = true;
}
